import * as React from 'react'

import { Box, type Colors, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import './index.styles.css'
interface Props {
  color: Colors
  visible?: boolean
}

const Hint = ({ color, visible = true, children }: React.PropsWithChildren<Props>) => {
  if (!visible) return null
  return (
    <Box className={'FormWrapper_hints'} style={{ position: 'relative' }}>
      <Box
        style={{ position: 'absolute' }}
        padding="s24"
        background={color}
        border={{
          all: {
            width: 's1',
            color: 'grey200',
            style: 'solid',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
      >
        <Text.Normal color="grey1000" weight="normal" size="100">
          {children}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default observer(Hint)
